<template>
  <div class="">
    <div class="days">
      <div
        :class="index === 5 || index === 6 ? 'day-color' : ''"
        class="day"
        v-for="(day, index) in Object.keys(days)"
        :key="day"
      >
        <p>{{ day }}</p>
        <input
          v-model.number="days[day]"
          type="number"
          max="24"
          min="0"
          step="1"
        />
      </div>
      <div :class="'day-color'" class="day">
        <p>Św.</p>
        <input
          v-model.number="holidaysNumberOfHours"
          type="number"
          max="24"
          min="0"
          step="1"
        />
      </div>
    </div>
    <div class="date-from">
      <dod-custom-date-input
        title="Obowiązuje od"
        :minDate="getMinDateForNewSchedule()"
        :placeholder="dateFrom"
        :isRequired="true"
        @dateChange="(e) => (dateFrom = e)"
      />
    </div>
    <div class="date-to">
      <dod-custom-date-input
        title="Obowiązuje do"
        :placeholder="dateTo"
        :isRequired="true"
        @dateChange="(e) => (dateTo = e)"
      />
    </div>
    <div class="holidays-select">
      Święta:

      <div class="d-flex mr-4 ml-4 holiday-input">
        <input
          id="holidaysIncluded"
          name="holidaysIncluded"
          type="radio"
          v-model="holidaysIncluded"
          :value="true"
        />
        <label for="holidaysIncluded">Tak</label>
      </div>

      <div class="d-flex mr-4 holiday-input">
        <input
          id="holidaysNotIncluded"
          name="holidaysIncluded"
          type="radio"
          v-model="holidaysIncluded"
          :value="false"
        />
        <label for="holidaysNotIncluded">Nie</label>
      </div>
    </div>

    <div class="buttons">
      <custom-button
        title="Anuluj"
        :gradient="false"
        :gray="true"
        custom-styles="border-radius: 50px; width: 50%;"
        @click="cancelEditing"
      />
      <custom-button
        title="Zapisz"
        :gradient="true"
        custom-styles="border-radius: 50px; width: 50%;"
        @click="saveSchedule"
      />
    </div>
  </div>
</template>

<script>
import DodCustomDateInput from "./DodCustomDateInput.vue";
import moment from "moment";
import CustomButton from "../CustomButton.vue";
export default {
  components: { DodCustomDateInput, CustomButton },
  name: "CustomerScheduleEditing",
  props: ["customerId"],
  emits: ["cancelEditing", "scheduleUpdated"],
  data: () => {
    return {
      days: {
        Pon: 0,
        Wt: 0,
        Śr: 0,
        Czw: 0,
        Pt: 0,
        Sob: 0,
        Nd: 0,
      },
      dateFrom: "",
      dateTo: "",
      holidaysIncluded: false,
      holidaysNumberOfHours: 0,
    };
  },
  mounted() {
    if (this.schedule) {
      this.days.Pon = this.schedule.mondayNumberOfHours;
      this.days.Wt = this.schedule.tuesdayNumberOfHours;
      this.days.Śr = this.schedule.wednesdayNumberOfHours;
      this.days.Czw = this.schedule.thursdayNumberOfHours;
      this.days.Pt = this.schedule.fridayNumberOfHours;
      this.days.Sob = this.schedule.saturdayNumberOfHours;
      this.days.Nd = this.schedule.sundayNumberOfHours;
      this.dateFrom = moment(this.schedule.dateFrom).format("YYYY-MM-DD");
      this.dateTo = moment(this.schedule.dateTo).format("YYYY-MM-DD");
      this.holidaysIncluded = this.schedule.holidaysIncluded;
      this.holidaysNumberOfHours = this.schedule.holidaysNumberOfHours;
    } else {
      this.dateFrom = this.getMinDateForNewSchedule();
      this.dateTo = this.getMinDateForNewSchedule();
    }
  },
  methods: {
    getMinDateForNewSchedule() {
      return moment().add(1, "day").format("YYYY-MM-DD");
    },
    cancelEditing() {
      this.$emit("cancelEditing");
    },
    async saveSchedule() {
      const response = await this.$store.dispatch("addCustomerSchedule", {
        customerId: this.customerId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        holidaysIncluded: this.holidaysIncluded,
        mondayNumberOfHours: this.days.Pon || 0,
        tuesdayNumberOfHours: this.days.Wt || 0,
        wednesdayNumberOfHours: this.days.Śr || 0,
        thursdayNumberOfHours: this.days.Czw || 0,
        fridayNumberOfHours: this.days.Pt || 0,
        saturdayNumberOfHours: this.days.Sob || 0,
        sundayNumberOfHours: this.days.Nd || 0,
        holidaysNumberOfHours: this.holidaysNumberOfHours || 0,
      });
      if (response) {
        this.$notify({
          group: "success",
          text: "Zapotrzebowanie zostało zaktualizowane",
        });
        this.$emit("cancelEditing");
        this.$emit("scheduleUpdated");
        await this.$store.dispatch("getCustomerSchedule", {
          customerId: this.customerId,
        });
        await this.$store.dispatch("getCustomerMessages", {
          customerId: this.customerId,
        });
      } else {
        this.$notify({
          group: "error",
          text: "Nie udało się zaktualizować zapotrzebowania",
        });
      }
    },
  },

  computed: {
    schedule() {
      return this.$store.getters.getDodSelectedCustomerSchedule?.data[0];
    },
  },
};
</script>

<style scoped>
.box {
}
.days {
  border-radius: 5px;
  border: 1px solid rgba(9, 7, 65, 0.25);
  display: flex;
  width: 100%;
  margin: 2rem 0;
}
.day {
  border-right: 1px solid rgba(9, 7, 65, 0.25);
  flex: 1 1 0px;
  height: 54px;
  text-align: center;
}
.day:last-child {
  border-right: none;
}
.holidays-select {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
}
.holidays-select label {
  margin-bottom: 0;
  margin-left: 5px;
  cursor: pointer;
}
.holiday-input {
  cursor: pointer;
}
.buttons {
  display: flex;
  width: 100%;
  gap: 1rem;
}
.day input {
  border: none;
  text-align: center;
  border-bottom: 1px solid black;
  width: 100%;
  background: none;
}
.day input:focus {
  outline: none;
}
.day-color {
  background: rgba(226, 3, 126, 0.07);
}

.day input::-webkit-outer-spin-button,
.day input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.day input[type="number"] {
  -moz-appearance: textfield;
}
</style>